import { render, staticRenderFns } from "./matrix.vue?vue&type=template&id=6c2ae7ea&scoped=true"
import script from "./matrix.vue?vue&type=script&lang=js"
export * from "./matrix.vue?vue&type=script&lang=js"
import style0 from "./matrix.vue?vue&type=style&index=0&id=6c2ae7ea&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2ae7ea",
  null
  
)

export default component.exports